/**
 * `/`: home screen for a fully authenticated, validated volunteer — the
 * session feature's "Démarrer" screen (`src/features/session/pages/StartPage.tsx`).
 * Renders under `RequireFullAccess` inside `AppShell`.
 */
import { StartPage } from '../features/session/pages/StartPage';

/**
 * Render the home screen.
 *
 * @returns The page element.
 */
export function HomePage() {
  return <StartPage />;
}
